import { useMemo } from 'react';

import { doc, DocumentReference } from 'firebase/firestore';

import { useDocumentData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import { USGA_COURSE_REFRESH_PATH } from '../types/UsgaCourseRefresh';

import type { UsgaCourseRefresh } from '../types/UsgaCourseRefresh';

/** God only: the status of the last "Refresh courses" (USGA posting seasons) run. */
export default function useUsgaCourseRefresh() {
  const { isGod } = useAuth();
  const ref = useMemo(
    () => (isGod ? doc(firestore, USGA_COURSE_REFRESH_PATH) as DocumentReference<UsgaCourseRefresh> : null),
    [isGod],
  );
  const [refresh, isLoading, error] = useDocumentData<UsgaCourseRefresh>(ref);
  return { refresh: refresh ?? null, isLoading, error };
}
